export default __webpack_public_path__ + "static/media/swelegend.bf4cbfd6.png";